<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        @searchByParameter="searchByParams"
        @bulkUpload="bulkUpload"
        @rejectDownload="rejectDownload"
        @exportData="exportData"
        @getExcel="getExcel"
        @add="openAddSlider"
        :searchText="$t('MDM_SEARCH')"
      />
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div
        class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <MdmHeader
          :headers="sectionHeaders"
          :hasColumnPicker="true"
          :noCheckbox="true"
          :maxDisplayColumn="maxDisplayColumn" />
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">{{$t('MDM_NO_DATA_FOUND')}}</div>
        </div>
        <MdmRow
          v-else
          v-for="(freightZone, index) in freightZoneList"
          :key="index"
          :data="freightZone"
          :headers="sectionHeaders"
          :isRowClickable="showEdit"
          @routeToDetails="openEditForm(freightZone)"
        />
      </div>
      <div class="slideleft_menu">
        <SecFilter
          v-if="!isLoading"
          :selectedFilters="filterConstant"
          :filters="filters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply" />
      </div>
    </div>
    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-20" v-if="showForm">
          <Drawer
            :visible.sync="showForm"
            direction="rtl"
            size="500px"
            :modal="true"
            :withHeader="false"
            :wrapperClosable="false"
            :append-to-body="true"
            class="default-drawer" >
            <Link :underline="false" class="nav-close" @click="closeSlider">
              <svgicon
                name="cancelwhite"
                width="12"
                height="12"
                :original="true" />
            </Link>
            <Form
              v-if="!isLoadingFormConstants"
              :formConstant="addFormConstants"
              :data="selectedRow"
              :isEdit="isEditForm"
              :showExport="$hasPermission('export_freight_zone_level')"
              sectionTitle="Freight zone"
              @cancel="closeSlider"
              @add="add"
              @update="update"
              @export="frieghtZoneExport($event)" />
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { freightZoneLevel } from 'pando-constants';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import FilterWrapper from '@common/components/FilterWrapperV2';
import Form from '@common/components/mdm-v2/Form';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import { typeFilterOptions, filters } from '@/constants/mdm-v2/freight-zone';
import { capitalize } from 'lodash';

import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';

export default {
  name: 'FreightZones',
  components: {
    PrimaryFilter,
    SecFilter,
    MdmHeader,
    MdmRow,
    FilterWrapper,
    Form,
  },
  mixins: [SharedMdm, SecFilterMixin],
  data() {
    return {
      filters,
      filterConstant: [],
      skipEditPermission: false,
      defaultValues: {},
      openSlideleft: false,
      maxDisplayColumn: 4,
      isLoadingFormConstants: false,
      typeFilterOptions,
    };
  },
  created() {
    this.setDefaults();
    this.loadSearchFromSession();
    this.loadFilterFromSession();
    this.loadMore();
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
    }),
    ...mapState('mdmV2', ['isLoading', 'all', 'isUploading']),
    freightZoneList() {
      return this.list && this.list.map(freightZone => ({
        id: freightZone.id,
        name: capitalize(freightZone.name),
        pincodes: freightZone.pincodes,
        zone_type: capitalize(freightZone.zone_type),
        locations: freightZone.locations,
        transporter_name: freightZone.transporter_name,
        transporter_ref_id: freightZone.transporter_ref_id,
      }));
    },

  },
  methods: {
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    searchApply() {
      this.applyFilters();
      this.openSlideleft = false;
      const filter = this.constructFilterPayload();
      this.searchByFilter(filter);
    },
    loadFilterFromSession() {
      this.loadFilters();
      this.applyFilters();
      this.filterParams = this.constructFilterPayload();
    },
    setDefaults() {
      this.defaultValues.type = this.typeFilterOptions.find(item => item.id === -1);
    },
    frieghtZoneExport(data) {
      this.exportData(null, data.id);
    },
    constructConstantForFilter() {
      if (this.configurations.freight_zone_level === freightZoneLevel.TRANSPORTER) {
        this.filterConstant = [
          [
            {
              type: 'List',
              category: this.filters.TYPE,
              default: this.defaultValues.type,
              selected: this.defaultValues.type,
              list: this.typeFilterOptions,
              idLabel: 'name',
              queryParamString: 'zone_type',
              optional: true,
            },
          ],
        ];
      }
    },
    openEditForm(data) {
      this.selectedRow = {
        id: data.id,
        name: data.name,
        pincodes: data.pincodes.map((pincode, index) => ({
          pincode,
          sno: index + 1,
        })),
        zone_type: data.zone_type,
        locations: data.locations.map((location, index) => ({
          location,
          sno: index + 1,
        })),
        transporter_ref_id: data.transporter_ref_id,
      };
      this.isEditForm = true;
      this.openSlider();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParams(params) {
      this.searchByParameter(params);
      this.saveSearchToSession();
    },
  },
};
</script>

